import { VERSION } from "$env";

export interface GlobalState {
	/** Whether the router finished loading the first route. */
	loaded: boolean;
	newestVersion: string;
	userAgent?: string;
}

export const globalState = $state<GlobalState>({
	loaded: false,
	newestVersion: VERSION,
});
